import { render } from "./FieldInstanceInput.vue?vue&type=template&id=4b3778b5"
import script from "./FieldInstanceInput.vue?vue&type=script&lang=js"
export * from "./FieldInstanceInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__